import { UseSearchFieldStatesReturn } from '@/features/ban-hang/cong-no-khach-hang/so-chi-tiet-cong-no-theo-khach-hang/hooks';
import { FormField, SearchField } from '@/components/custom/erp';
import { khachHangSearchColumns, QUERY_KEYS } from '@/constants';
import { Label } from '@/components/ui/label';
import { KhachHang } from '@/types/schemas';

interface DetailsTabProps {
  searchFieldStates: UseSearchFieldStatesReturn;
}

const DetailsTab: React.FC<DetailsTabProps> = ({ searchFieldStates }) => {
  return (
    <div className='h-36 space-y-2 p-4'>
      <div className='flex flex-col space-y-1'>
        <div className='flex items-center'>
          <Label className='w-32'>Mã khách hàng</Label>
          <SearchField<KhachHang>
            columnDisplay='customer_code'
            displayRelatedField='customer_name'
            searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}`}
            searchColumns={khachHangSearchColumns}
            value={searchFieldStates.customer?.customer_code || ''}
            relatedFieldValue={searchFieldStates.customer?.customer_name || ''}
            onRowSelection={searchFieldStates.setCustomer}
          />
        </div>
        <div className='flex items-center'>
          <FormField
            name='mau_bc'
            label='Mẫu báo cáo'
            labelClassName='w-32'
            type='select'
            options={[
              { value: 20, label: 'Mẫu tiền chuẩn' },
              { value: 30, label: 'Mẫu ngoại tệ' }
            ]}
            className='w-[400px]'
          />
        </div>
      </div>
    </div>
  );
};

export default DetailsTab;
